import { ReactGlide } from './react/react-glide.jsx';
import { ReactGlideCarousel } from './react/react-glide-carousel.jsx';
import { ReactGlideImageSlider } from './react/react-glide-image-slider.jsx';
import { AccentCircles } from './react/accent-circles.jsx';
import { setupYouTubeEmbeds } from './lib/youtube-embeds.js';

window.$ = jQuery.noConflict(true);

const DOM_LOAD_EVENT = 'DOMContentLoaded';

/**
 * Setup on load functionality.
 * @author LWK
 */
document.addEventListener(DOM_LOAD_EVENT, () => {
	// Dynamic Icons - must be in spritemap
	Array.from(document.querySelectorAll('[data-icon]')).forEach((el) => {
		const svg = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'svg'
		);
		svg.setAttribute('viewBox', '0 0 16 16');
		svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
		const use = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'use'
		);
		use.setAttribute('href', `#icon-${el.dataset.icon}`);
		svg.appendChild(use);
		el.appendChild(svg);
		el.classList.add('icon', `icon-${el.dataset.icon}`);
	});
	// YouTube Embed Hijacking
	console.log('DOM_LOAD is firing');
	setupYouTubeEmbeds();
});

// Stop all video embeds in modals when modal is closed.
$(document).ready(function () {
	$('.modal').on('hidden.bs.modal', function (e) {
		if (e.target.classList.contains('modal-video')) {
			return;
		}
		var $iframes = $(e.target).find('iframe');
		$iframes.each(function (index, iframe) {
			$(iframe).attr('src', $(iframe).attr('src'));
		});
	});
});
